var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',{staticClass:"war-room-post-poll-results"},_vm._l((_vm.poll.choices),function(choice){return _c(_setup.WarRoomPostPollResultsChoice,{key:choice.id,style:({ order: choice.position }),attrs:{"poll":_vm.poll,"choice":choice}})}),1)
}
var staticRenderFns = []

export { render, staticRenderFns }